




































import { Vue, Component } from 'vue-property-decorator'
import { $auth } from '@/services/Auth'

@Component
export default class Navbar extends Vue {

	oldPass = ''
	password = ''
	repeat = ''
	passChangeError = ''

	get email() {
		return $auth.user.attributes.email
	}

	signout() {
		$auth.signOut()
	}

	changePassword(e) {
		e.preventDefault()
		this.passChangeError = ''
		const currentInput = this.$refs.repeat as HTMLInputElement
		const passInput = this.$refs.password as HTMLInputElement
		const repeatInput = this.$refs.repeat as HTMLInputElement

		currentInput.setCustomValidity('')
		passInput.setCustomValidity('')
		repeatInput.setCustomValidity('')

		if(!this.oldPass) {
			currentInput.setCustomValidity('Please enter your current password.')
		} else if(!this.password) {
			passInput.setCustomValidity('Please enter a password.')
		} else if(this.repeat !== this.password) {
			repeatInput.setCustomValidity('Passwords must match.')
		}

		const valid = (this.$refs.passwordForm as HTMLFormElement).reportValidity()
		if(!valid) {
			return
		}
		
		$auth.changePassword(this.oldPass, this.password)
			.then(() => {
				(this.$refs.modal as any).hide()
				this.reset()
			})
			.catch(err => {
				this.passChangeError = err.message
			})
	}

	reset() {
		this.oldPass = ''
		this.password = ''
		this.repeat = ''
	}

}
